<template>
	<div id="initialBalance"  class="public-content">
		<div class="public-content-top">
			<el-form inline>
				<el-form-item>
					<el-checkbox  @change="handleCheck"  v-model='isChildrenShow' style='padding-right: 20px;'>显示数量</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-button  size="small" @click="openImportIn">导入</el-button>
					<el-button  
						size="small" 
						v-for = "btn in buttonList"
						:key = "btn.id"
						@click="handleBtnOpera(btn)"
					>
						{{ btn.name }}
					</el-button>
        
					<el-button class='minButton' size="small" @click="trialBalance">试算平衡
          </el-button>
				</el-form-item>
			</el-form>
		</div>
      <el-tabs type="card" v-model="tabVal" @tab-click="handleClickChanges">
        <el-tab-pane v-for="(item,index) in listLabel.typelist" :key="index" :label="item" :name="item">
        </el-tab-pane>
      </el-tabs>
		<!-- 公共table 样式 -->

		<public-table :table='tableData' v-if='refresh'>
			<template v-for="(cell,index) in tableData.config" v-if="cell.show == 'template'" slot-scope="props" :slot="cell.value">
				<template v-if="cell.value === 'name'">
					<div :key = "index">
						<i
							:class="[{
								'el-icon-circle-plus-outline': props.scope.row.auxiliary && props.scope.row.auxiliary.length > 0,
								'el-icon-remove-outline': props.scope.row.justAuxiliary
							}]"
							:title="props.scope.row.auxiliary && props.scope.row.auxiliary.length > 0 ? '设置辅助核算' : props.scope.row.justAuxiliary && '删除辅助核算'"
							@click="setAuxiliary(props.scope)">
						</i>
						<span v-text="props.scope.row.name" ></span>
					</div>
				</template>
				<template v-else-if="cell.value !== 'name'">
					<!-- 没有辅助核算 并且没有下级 -->
					<el-input
            :disabled="!isEdit"
						v-if="!props.scope.row.auxiliary && !props.scope.row.hasChild"
						v-model="props.scope.row[cell.value]"
						size="small"
						:key = "index"
						@focus="handleEditField($event, props.scope.row, cell.value)"
						@blur="handleCancelEdit($event, props.scope, cell.value)">
					</el-input>
					<!-- 有辅助核算 -->
					<span v-else v-text="props.scope.row[cell.value]" :key = "index"></span>
				</template>
			</template>
			<!-- 期初余额数量 -->
			<template slot-scope="props" slot="initialAmount">
				<el-input v-model="props.scope.row['initialAmount']"
              :disabled="!isEdit"
						  v-if="props.scope.row.numberAccounting && !props.scope.row.auxiliary && !props.scope.row.hasChild"
						  @focus="handleEditField($event, props.scope.row, 'initialAmount')"
						  @blur="handleCancelEdit($event, props.scope, 'initialAmount')" size="small">
				>
				</el-input>
				<span v-else v-text="props.scope.row['initialAmount']"></span>
			</template>
			<!-- 本年累计借方数量 -->
			<template slot-scope="props" slot="yearDebitAmount">
				<el-input v-model="props.scope.row['yearDebitAmount']"
              :disabled="!isEdit"
						  v-if="props.scope.row.numberAccounting && !props.scope.row.auxiliary && !props.scope.row.hasChild"
						  @focus="handleEditField($event, props.scope.row, 'yearDebitAmount')"
							@blur="handleCancelEdit($event, props.scope, 'yearDebitAmount')" size="small">
				>
				</el-input>
				<span v-else v-text="props.scope.row['yearDebitAmount']"></span>
			</template>
			<template slot-scope="props" slot="yearCreditorAmount">
				<el-input v-model="props.scope.row['yearCreditorAmount']"
              :disabled="!isEdit"
				      v-if="props.scope.row.numberAccounting && !props.scope.row.auxiliary && !props.scope.row.hasChild"
						  @focus="handleEditField($event, props.scope.row, 'yearCreditorAmount')"
							@blur="handleCancelEdit($event, props.scope, 'yearCreditorAmount')" size="small">
				>
				</el-input>
				<span v-else v-text="props.scope.row['yearCreditorAmount']"></span>
			</template>
		</public-table>
		<!-- 试算平衡弹框 -->
		<el-dialog
			title="试算平衡"
			:visible.sync="istrialBalanceShow"
			:close-on-click-modal="false"
			width='500px' class='default-dialog'>
			<div class="block" v-if="isItBalanced">
				<p :class="{ 'red': !isItBalanced.isLendingBalanced }">
					{{ isItBalanced.isLendingBalanced ? '恭喜，您录入的初始余额试算平衡！' : '抱歉，您录入的初始余额试算不平衡，请修改并提交后再试算！'}}
				</p>
				<!-- <p :class="{ 'red': !isItBalanced.periodsBegin }">
					{{ isItBalanced.periodsBegin ? '恭喜，您录入的资产负债表期初平衡！' : '抱歉，您录入的资产负债表期初试算不平衡！'}}
				</p> -->
				<p :class="{ 'red': !isItBalanced.yearBegin }">
					{{ isItBalanced.yearBegin ? '恭喜，您录入的资产负债表年初平衡！' : '抱歉，您录入的资产负债表年初试算不平衡！'}}
				</p>
				<p :class="{'red': !isItBalanced.startPrif}" v-if="isItBalanced.startPrif!==undefined ">
					{{ isItBalanced.startPrif ? '恭喜，您录入的期初利润勾稽关系平衡！' : '抱歉，您录入的期初利润勾稽关系不平衡！'}}
				</p>
			</div>
			<!-- 表格 -->
			<public-table :table='tableData_SS'></public-table>
		</el-dialog>
		<!--导入期初-->
		<import-file 
			:isPublicImportShow.sync = 'isPublicImportShow'
			@downLoadTemplate='downLoadTemplate'
			@exportIn='exportIn' 
			:isImportFilesLoading='isImportFilesLoading'
			title='导入期初'>
				
		</import-file>
		<!-- 添加辅助核算 -->
		<add-auxiliary-account
			:showVisible.sync="isShowDialog"
			:subjectId="subjectId"
			:rowIndex="rowIndex"
			@handleCallback="handleCallback">
		</add-auxiliary-account>
	</div>
</template>

<script>
import publicTable from '@/components/publicTable'
import addAuxiliaryAccount from '@/components/dialog/addAuxiliaryAccContent'
import importFile from "@/components/importDialog/importFile.vue"

export default {
	components:{
		publicTable,
		addAuxiliaryAccount,
		importFile
	},
	data(){
		return {
			isImportFilesLoading:false,
			isPublicImportShow:false,  // 导入
			istrialBalanceShow: false,   // 试算平衡显示隐藏控制
			rowList: [],    // 自动保存
			formDatas: {}, // 辅助核算
			tabVal:'',
			refresh: true,    // 刷新表格
			buttonList:[], // 按钮数组
			isChildrenShow:false,
			autoSave:true,
			dialog:{
				modal:false,
				loading:false,
			},
			tableData: {
        isNotSuspensionShow: true,
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
        Maxheight: "500px",
				key: 0,						// 渲染时使用
				config: [{
					label: '编码',
					value: 'code',
					show: 'normal',
					name : "noChangeable"
				},{
					label: '名称',
					value: 'name',
					width: 350,
					show: 'template',
					name : "noChangeable"
				},{
					label: '方向',
					value: 'creditDirection',
					width: 80,
					show: 'normal',
					name : "noChangeable"
				},{
					label: '期初余额',
					value: 'balance',
					show: 'template',
					name : "changeable",
					showChild : false,
					children:[
							  {
							label: '数量',
							value: 'initialAmount',
							width: 120,
							show: 'template'
						},{
							label: '本位币',
							value: 'balance',
							width: 120,
							show: 'template'
						}
					]
				},{
					label: '本年累计借方',
					value: 'borrow',
					show: 'template',
					name : "changeable",
					showChild : false,
					children:[
							{
							label: '数量',
							value: 'yearDebitAmount',
							width: 120,
							show: 'template'
						},{
							label: '本位币',
							value: 'borrow',
							width: 120,
							show: 'template'
						}
					]
				},{
					label: '本年累计贷方',
					value: 'loan',
					show: 'template',
					name : "changeable",
					showChild : false,
					children:[
								{
							label: '数量',
							value: 'yearCreditorAmount',
							width: 120,
							show: 'template'
						},{
							label: '本位币',
							value: 'loan',
							width: 120,
							show: 'template'
						}
					]
				},{
					label: '年初余额',
					value: 'consequence',
					show: 'normal',
					name : "changeable",
					showChild : false,
					children:[
								{
							label: '数量',
							value: 'yearBeginAmount',
							width: 120,
							show: 'normal'
						},{
							label: '本位币',
							value: 'consequence',
							width: 120,
							show: 'normal'
						}
					]
				}],
				data: [],
				page: {
					pageNo: 1,
					pageSize: 20,
					total: 10
				},
				center: {
					textAlign: 'center'
				}
			},

			listLabel:{
				typelist:[]
			},
			listDataDialog:[],
			data: {},					// table列表数据
			oldVal: {					// 记录前一个改变的数据
				balance: '',
				borrow: '',
				loan: '',
			},
			delVal:'',					// 记录待删除数据
			dataChange: {},				// 修改后的数据
			activeIndex: 0,				// 当前Tab标签下标
			subjectId: '',				// 科目ID
			rowIndex: 0,				// 当前点击行下标
			isShowDialog: false,		// 是否显示辅助核算弹窗
			isShowTrialBalance: false,	// 是否显示试算平衡弹窗
			tableData_SS: {                    // 试算平衡表格
				Maxheight: 400,				// 限定高度
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [{
					label: '项目',
					value: 'name',
					width: 120,
					show: 'normal'
				},{
					label: '借方余额',
					value: 'debitsum',
					show: 'normal'
				},{
					label: '贷方余额',
					value: 'creditsum',
					show: 'normal'
				},{
					label: '差额',
					value: 'sumDifference',
					show: 'normal'
				}],
				data: [],
				operation: {
					label: '操作',
					value: 'operation',
					data: []
				},
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center'
				}
			},
			isItBalanced: '',  // 试算是否平衡
			isFirstActive: false,
			firstGet: true,
		}
	},
	created(){
		this.getAllSubjectType();
		this.getImportButton();
	},
	computed: {
		//获取this.tableData.config里面名为changeable的数据集合
		getTableDatas(){
			let getTableDatas = this.tableData.config.filter((item)=>{
				if(item.name == "changeable"){
					return item;
				}
			})
			return getTableDatas;
		},
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		},
    // 仅首账期修改期初数据
    isEdit() {
      return this.getAccountPeriod == this.nowYearPeriod
    },
    getAccountPeriod() {
      return this.$store.state.accountInfo.yearPeriods.yearPeriods
    },
    nowYearPeriod() {
      return this.$store.state.accountInfo.accountInfoData.nowYearPeriod
    },
	},
	activated() {
		if(this.getClickCache && this.isFirstActive) {
			this.getAllSubjectType();
		}
		this.isFirstActive = true;
	},
  mounted() {
    this.getTableH();
    this.getAccountPeriods();
  },
	methods:{
    // 获取会计期间/初始化数据
    async getAccountPeriods() {
      await this.$store.dispatch("getAllYearPeriodsData");
    },
    getTableH() {
      let maxBox = document.getElementById('initialBalance').clientHeight - 120;
      this.tableData.Maxheight = maxBox + "px";
    },
		// 获取按钮
		getImportButton() {
			let params={
				permissions:'ac:initialBalance:export',
			}
			try {
				this.buttonList = [];
				this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
					if(res && res.data.code == 1) {
						if(res.data.data.length){
							this.buttonList = res.data.data;
						}
					}
				})
			}catch(e){
			}
		},
		// 导入
		exportIn(data) {
			var params = new FormData();
	        // 导入验证 
	        if(data.length>1) {
	          return this.$message.warning('只能从列表选择一个上传哟!')
	        }
	        let fileOne = data[0];
	        let testmsg=fileOne.name.substring(fileOne.name.lastIndexOf('.')+1)
	        const extension = testmsg === 'xls'
	        const extension2 = testmsg === 'xlsx'
	        const isLt5M = fileOne.size / 1024 / 1024 < 5
	        if(!extension && !extension2) {
	          return this.$message({
	            message: '上传文件只能是 xls、xlsx格式!',
	            type: 'warning'
	          });
	        }
	        if(!isLt5M) {
	          return this.$message({
	            message: '上传文件大小不能超过 5MB!',
	            type: 'warning'
	          });
	        }

	         params.append('multipartFile',fileOne.raw);
	         params.append('cid',sessionStorage.getItem('cid'));
	         params.append('token',sessionStorage.getItem('token'));
	         try {
	          const instance = this.$http.create({
	            withCredentials: true
	          })
	          this.isImportFilesLoading = true;
	          instance.post(this.$rootUrl + 'initial/importFileInitial', params).then(res=>{
	          	this.isImportFilesLoading = false;
	            if(res && res.data.code == 1) {
	              this.isPublicImportShow = false;
	              this.$message.success("导入成功！");
	              this.getData(0);
	            }else {
	            	 this.$message.error(res.data.msg);
	            }
	          })
	         }catch(e) {

	         }
		},
		// 下载模板
		downLoadTemplate(data) {
			const params = {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
			}

			const router = this.$router.resolve({
				path: '/export/downInitial',
				query: params
			})

			location.href = this.$rootUrl + router.href
		},
		// 导入
		openImportIn() {
			this.isPublicImportShow = true;
		},
		// 操作按钮点击
		handleBtnOpera(i) {
			if(i.permission == "ac:initialBalance:export") { // 打印
				const params = {
					cid: sessionStorage.cid,
					token: sessionStorage.token,
					type:"init"
				}

				const router = this.$router.resolve({
					path: '/export/downInitial',
					query: params
				})

				window.open(this.$rootUrl + router.href)
			}
		},
		getData(i){
			//快速访问
			const _=this;
			//if (!_.data[`subject_${i}`]) {
				_.tableData.loading = true;
				_.$http.post('initial/list',{
					type:_.tabVal
				}).then(res=>{
					_.tableData.loading = false;
					if(res && res.data.code == '1'){
						_.$set(_.data, `subject_${i}`, res.data.data);
						_.$set(_.tableData, 'data', _.data[`subject_${i}`]);
					}
				}).catch(()=>{
					_.tableData.loading = false;
				});
			//}else {
				//_.$set(_.tableData, 'data', _.data[`subject_${i}`])
			//}
		},
		//获取科目类别
		getAllSubjectType(){
			const _=this;
			_.$http.post('subject/getSubjectType',{}).then((res)=>{
				if(res && res.data.code == '1'){
					_.listLabel.typelist = res.data.data;
					if(_.firstGet) {
						_.tabVal= res.data.data[0];
						_.firstGet = false;
					}
					_.tableData.key = 0;
					_.getData(0);
					_.$set(_.dataChange, 'data_0', []);
				}
			})
		},
		// tab切换
		handleClickChanges(tab) {
			if (!this.dataChange[`data_${tab.index}`]) {
				this.$set(this.dataChange, `data_${tab.index}`, []);
			}
			this.tableData.key = tab.index;
			this.activeIndex = tab.index;
			this.tabVal = tab.name;
			this.getData(tab.index);
		},
		//checkBox点击事件
		handleCheck(){
			this.getTableDatas.forEach((item)=>{
				item.showChild = this.isChildrenShow;
			})
			if(!this.isChildrenShow){
				this.refresh = false;
				this.$nextTick(()=>{
					this.refresh = true;
				})
			}
		},
		// 获取焦点时选中数据
		handleEditField (e, row, name) {
			const input = e.target;
			for (const rowKey in row) {
				for (const key in this.oldVal) {
					if (key === rowKey) {
						if(parseFloat(row[key])%1===0){
							this.oldVal[key] = parseFloat(row[key]);
						}else{
							this.oldVal[key] = parseFloat(row[key]).toFixed(2);
						}

					}
				}
			}
			input.select();
		},
		// 失去焦点
		handleCancelEdit (e, data, name) {

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			const { $index, row } = data;
			let obj = {
				id: row.id,
				justAuxiliary: row.justAuxiliary,
				balance: row.balance,
				borrow: row.borrow,
				loan: row.loan,
				creditDirection: row.creditDirection,
				consequence: row.consequence,
				initialAmount: row.initialAmount,
				yearDebitAmount: row.yearDebitAmount,
				yearCreditorAmount: row.yearCreditorAmount,
				yearBeginAmount: row.yearBeginAmount,
			};
			//禁止输入数字意外的符号 并实时展示
			let val = e.target.value.replace(/[^0-9.-]/g,'');
			if(parseFloat(val)%1===0){
				var value = parseFloat(val);
				this.tableData.data[$index][name] = value;
			}else{
				var value = val;
				if(name != "initialAmount" && name != "yearDebitAmount" && name != "yearCreditorAmount") {
					value = parseFloat(val).toFixed(2) || 0;
				}
				this.tableData.data[$index][name] = value;
			}

			let isVal = [];
			const result = this.dataChange[`data_${this.activeIndex}`].some(item => item.id == obj.id);

			if (value !== '' && !isNaN(value) && this.oldVal[name] !== value) {
				// 如果已有数据，则在原基础上修改，否则新建
				if (result) {
					this.setBalance(obj.id, $index, value, name);
				} else {
					// 只要有一个为true时,则新建新对象
					// if (isVal.includes(true)) {
						this.dataChange[`data_${this.activeIndex}`].push(obj);

						const index = this.dataChange[`data_${this.activeIndex}`].length - 1;

						this.$set(this.dataChange[`data_${this.activeIndex}`][index], name, isNaN(value) ? this.oldVal[name] : value);
						this.countEarlyBalance({ row: this.dataChange[`data_${this.activeIndex}`][index], $index }, 'dataChange', index);
					// }
				}
			} else {
				if (isNaN(value)) {
					this.tableData.data.forEach(item => {
						if (item.id == row.id) {
							this.$set(item, name, this.oldVal[name]);
						}
					});
				} else {
					let newIndex = '', isClear = [];

					this.setBalance(obj.id, $index, value, name);

					const newData = this.dataChange[`data_${this.activeIndex}`].filter((item, index) => {
						if (item.id == row.id) {
							newIndex = index;
							return item
						}
					})[0];

					for (const key in newData) {
						if (key !== 'id' && key !== 'justAuxiliary' && key !== 'creditDirection' && key !== 'consequence') {
								newData[key] != this.oldVal[key] ? isClear.push(true) : isClear.push(false)
							}
					}

					if (!isClear.includes(true)) {
						this.dataChange[`data_${this.activeIndex}`].splice(newIndex, 1);
					}
				}
			}
			this.countBalance(data, name);

			// 开启自动保存功能

			this.rowList = [];
			row.subjectId = row.id;
			this.rowList.push(row)
			if(this.dataChange[`data_${this.activeIndex}`].length) {
				this.$http.post('initial/batchUpdate' , {list: this.rowList}).then(res=>{
					if(res && res.data.code==1) {

					}else {
						this.getData();
					}
				})
				this.dataChange[`data_${this.activeIndex}`] = [];
			}


		},
		// 设置余额
		setBalance (id, $index, value, name) {

			this.dataChange[`data_${this.activeIndex}`].forEach((item, index) => {
				if (item.id == id) {
					item[name] = isNaN(value) ? this.oldVal[name] : value;
					this.$set(this.data[`subject_${this.activeIndex}`][$index], name, isNaN(value) ? this.oldVal[name] : value);
					this.$set(this.tableData.data[$index], name, isNaN(value) ? this.oldVal[name] : value);
					this.countEarlyBalance({ row: item, $index }, 'dataChange', index);
				}
			})

		},
		// 计算余额(如果是辅助核算，子级变动时父级重新计算)
		countBalance (data, name) {
			const { row, $indedx } = data;
			let parentIndex = '', sum = 0, values = [], parentData = '',preList = [];

			if (row.superSubjectId !== '0') {
				this.data[`subject_${this.activeIndex}`].forEach((item, index) => {
					if (item.id === row.superSubjectId) {
						parentIndex = index;
						parentData = item;
					}
					if (item.superSubjectId === row.superSubjectId) {
						values.push(Number(item[name]));
						preList.push(item)
					}
				})
				let flag = parentData.creditDirection // 主科目借贷方向
				if(preList.length) {
					preList.forEach(i=>{
						if(i[name]) {
							if(i.creditDirection == flag || name != 'balance') sum += Number(i[name]);
							else sum -= Number(i[name]);
						}
					})
				}
				if(name != "initialAmount" && name != "yearDebitAmount" && name != "yearCreditorAmount") {
					sum = Number(sum.toFixed(2));
				}
				
				// if (values.length > 1) {
				// 	sum = values.reduce((prev, curr) => {
				// 		const value = Number(curr);
				// 		if(!isNaN(value)) {
				// 			if((parseFloat(prev)+parseFloat(curr))%1===0){
				// 				return (parseFloat(prev)+parseFloat(curr));
				// 			}else{
				// 				return (parseFloat(prev)+parseFloat(curr)).toFixed(2);
				// 			}

				// 		} else {
				// 			if(parseFloat(prev)%1===0){
				// 				return parseFloat(prev);
				// 			}else{
				// 				return parseFloat(prev).toFixed(2);
				// 			}

				// 		}
				// 	})
				// } else {
				// 	if(parseFloat(values[0])%1===0){
				// 		sum = parseFloat(values[0]);
				// 	}else{
				// 		sum = parseFloat(values[0]).toFixed(2);
				// 	}
				// }
				if (parentIndex !== '') {
					this.$set(this.data[`subject_${this.activeIndex}`][parentIndex], name, sum);
					this.$set(this.tableData.data[parentIndex], name, sum);
					// 计算父级年初余额
					this.countEarlyBalance({ row: this.tableData.data[parentIndex], $index: parentIndex });
				}
				this.countBalance({ row: parentData, $index: parentIndex }, name)
			}

			this.countEarlyBalance(data);
		},
		// 计算年初余额
		countEarlyBalance (data, name = null, index = null) {
			const { row, $index } = data;
			/*
			*	如果科目是借方，则期初余额(balance) + 本年累计贷方(loan) - 本年累计借方(borrow)
			* 	如果科目是贷方，则期初余额(balance) + 本年累计借方(borrow) - 本年累计贷方(loan) */
			let num = row.creditDirection === '借' ? (parseFloat(row.balance) + parseFloat(row.loan) - parseFloat(row.borrow)).toFixed(2) : (parseFloat(row.balance) + parseFloat(row.borrow) - parseFloat(row.loan)).toFixed(2);
			let nums = row.creditDirection === '借' ? (parseFloat(row.initialAmount) + parseFloat(row.yearCreditorAmount) - parseFloat(row.yearDebitAmount)) : (parseFloat(row.initialAmount) + parseFloat(row.yearDebitAmount) - parseFloat(row.yearCreditorAmount));

			if (name) {
				this.$set(this.dataChange[`data_${this.activeIndex}`][index], 'consequence', isNaN(num) ? 0 : num)
				this.$set(this.dataChange[`data_${this.activeIndex}`][index], 'yearBeginAmount', isNaN(nums) ? 0 : nums)

			}

			this.$set(this.data[`subject_${this.activeIndex}`][$index], 'consequence', isNaN(num) ? 0 : num);
			this.$set(this.data[`subject_${this.activeIndex}`][$index], 'yearBeginAmount', isNaN(nums) ? 0 : nums);
			this.$set(this.tableData.data[$index], 'consequence', isNaN(num) ? 0 : num);
			this.$set(this.tableData.data[$index], 'yearBeginAmount', isNaN(nums) ? 0 : nums);

		},
		// 试算平衡点击事件
		trialBalance()  {
			this.istrialBalanceShow = true;
			this.getTrialBalanceTableData();
		},
		// 获取平衡数据
		getTrialBalanceTableData () {
			try {
				 this.tableData.loading = true;
				this.$http.post('initial/getbalencesum',{}).then(res=>{
					this.tableData.loading = false;
					if(res && res.data.code == 1) {
						this.tableData_SS.data = res.data.data.list;
						this.isItBalanced = res.data.data.isItBalanced;				
					}
				})
			} catch (e) {
				this.tableData.loading = false;
			}
		},
		// 设置辅助核算
		setAuxiliary (data) {

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			const { $index, row } = data;
			if (row.auxiliary && row.auxiliary.length > 0) {
				this.handleAuxiliaryAdd(data);
			}
			if (row.justAuxiliary) {
				this.handleAuxiliaryDel(data);
			}
		},
		// 新增辅助核算初始余额
		handleAuxiliaryAdd (data) {
			const { row, $index } = data;

			this.subjectId = row.id;
			this.rowIndex = $index;
			this.isShowDialog = true;
		},
		// 接收子组件参数
		handleCallback (data) {
			const { value, type } = data;

			switch (type) {
				case 'add':
					this.addData(data);
					break;
			}
		},
		// 添加辅助核算
		addData (data) {
			const { value: row, rowIndex } = data;

			let pre = this.data[`subject_${this.activeIndex}`].slice(0, rowIndex+1);
			let last = this.data[`subject_${this.activeIndex}`].slice(rowIndex+1);
			let concatChildren = pre.concat(row);
			this.tableData.data = this.data[`subject_${this.activeIndex}`] = concatChildren.concat(last);
		},
		// 删除辅助核算初始余额
		handleAuxiliaryDel (data) {
			const { row } = data;

			try {
				this.$confirm(`确定删除“${row.code}-${row.name}”的财务初始余额吗？`, '提示', {
					type: 'warning',
					closeOnClickModal: false
				}).then(()=>{
					this.delVal = data;
					try {
						this.tableData.loading = true;
						this.$http.post('subjectAuxiliary/delete', { id: row.id }).then(res=>{
							this.tableData.loading = false;
							if(res && res.data.code == 1) {
								this.clearData(data);
								this.$message.success('删除成功！');
							}
						})
					} catch (e) {
						this.tableData.loading = false;
					}
					}).catch(()=>{

				})
			} catch (e) {

			}
		},
		// 清除数据
		clearData (data) {
			const { row, $index } = data;
			let parentIndex = '', parentData = '';

			if (row.superSubjectId !== '0') {
				this.data[`subject_${this.activeIndex}`].forEach((item, index) => {
					if (item.id === row.superSubjectId) {
						parentIndex = index;
						parentData = item;

						item = Object.assign(item, {
							balance: item.balance - this.delVal.row.balance,
							borrow: item.borrow - this.delVal.row.borrow,
							loan: item.loan - this.delVal.row.loan,
							consequence: item.consequence - this.delVal.row.consequence
						})
					}
				})
				this.clearData({ row: parentData, $index: parentIndex })
			} else {
				this.delData(this.delVal);
			}
		},
		// 删除相应数据（不刷新页面）
		delData (data) {
			const { row, $index } = data;

			this.data[`subject_${this.activeIndex}`].splice($index, 1);
			this.dataChange[`data_${this.activeIndex}`] = this.dataChange[`data_${this.activeIndex}`].filter(item => item.id === row.id);
			this.tableData.data = this.data[`subject_${this.activeIndex}`];
		},

	},
}
</script>

<style lang="less" scoped>
	#initialBalance{
    position: relative;
    height: calc(100% - 20px);
    box-sizing: border-box;
		.el-form {
			text-align: right;
		}
		.block {
			margin-bottom: 20px;
			p{
				padding: 5px 0;
			}
			.red {
				color: red;
			}
		}
    .public-content-top {
      top: 24px;
      position: absolute;
      right: 20px;
      z-index: 999;
    }
	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/initialBalance.vue